import CategoryListModelBase from '../_generated/modelBases/category-list-model-base';

export default class CategoryListModel extends CategoryListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
